// src/services/userService.ts
// Directory of assignable users, for AssigneePicker — any authenticated user
// can call this (unlike adminService.listUsers, which is admin-only).
import { api } from './api';

export interface DirectoryUser {
  _id: string;
  name: string;
  email: string;
  mobile?: string;
  role: string;
  roleId?: { _id: string; name: string; hierarchyLevel: number } | string;
  department?: string;
}

export const userService = {
  getAssignable: async (): Promise<DirectoryUser[]> => {
    const { data } = await api.get('/users');
    return data;
  },

  // ── Self-service profile ("me") ──────────────────────────────────────────

  updateProfile: (name: string) =>
    api.patch('/users/me', { name }).then(r => r.data),

  uploadAvatar: (file: File) => {
    const form = new FormData();
    form.append('avatar', file);
    return api.post<{ avatar: string }>('/users/me/avatar', form).then(r => r.data);
  },

  requestEmailChange: (newEmail: string, password: string) =>
    api.post<{ message: string }>('/users/me/email', { newEmail, password }).then(r => r.data),

  requestMobileChange: (mobile: string) =>
    api.post<{ message: string }>('/users/me/mobile', { mobile }).then(r => r.data),

  verifyMobile: (code: string) =>
    api.post<{ message: string; mobile: string }>('/users/me/mobile/verify', { code }).then(r => r.data),

  deleteAccount: (password: string) =>
    api.delete('/users/me', { data: { password } }).then(r => r.data),
};
